import React from 'react'
import BannerBreadCrumb from './BannerBreadCrumb';
import Banners from './Banners';
function BannerPage() {
    return ( 
        <div className="container-fluid">
        <BannerBreadCrumb />
        <Banners />
        </div>
        
     );
}

export default BannerPage;